export default __webpack_public_path__ + "static/media/aspas-verdes.e625425f.svg";